import request from '@/api/request'

// 我的用户列表
export const getListByPageByMine = (params) => {
    return request({
        url: 'acm/adm/bktClue/getListByPageByMine',
        method: 'get',
        params
    })
}

// 看课概览
export const getUserProgress = (params) => {
    return request({
        url: 'acm/adm/bktUserVideoProgress/getUserProgress',
        method: 'get',
        params
    })
}

// 看课记录
export const getUserRecordList = (params) => {
    return request({
        url: 'acm/adm/bktUserVideoRecord/getUserRecordList',
        method: 'get',
        params
    })
}

// 用户管理列表
export const getBktClueListByPage = (params) => {
    return request({
        url: 'acm/adm/bktClue/getListByPage',
        method: 'get',
        params
    })
}

// 租户列表
export const getCompanyList = (params) => {
    return request({
        url: 'base/adm/company/getListPage',
        params,
        method: 'get'
    })
}